import { useEffect, useState } from "react";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { Singleton } from "../../../../core/services/Singleton";
import { toast } from "react-toastify";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { BasicTable } from "../../../theme/Component/BasicTable";
import { Modal } from "../../../theme/Component/Modal";
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { _AnnotationReport, _EmployeeDecoration } from "../../../../core/services/dataBean/EntityCatalogVdos";
import { _single } from "../../../../core/services/dataBean/EntityCatalog";
import { AccountEditor } from "../../../editor/AccountEditor";
import { SelectTHConstantsValue } from "../../../bpm/config/Componentes/SelectTHConstantsValue";
import { SelectFunctionalID } from "../../../admin/configuracion/functionalID/SelectFunctionalID";
import { FileInput } from "../../../theme/Component/FileInput";
import { BasicSwitch } from "../../../theme/Component/BasicSwitch";
import { InputDate } from "../../../theme/Input/InputDate";


export const EmployeeDecoration = () => {

    const employeedecoration = useDataBean(_EmployeeDecoration);

    const single = Singleton.getInstance();
    const [lista, setLista] = useState<any>([]);
    const [state, setstate] = useState<any>(null);
    const [useaccount, setUseaccount] = useState<any>(null)
    const [account, seAccount] = useState<any>(null)
    const [beneficiario, setbeneficiario] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [cronograma, setcronograma] = useState<any>({ name: 'cronograma', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalAdd, setModalAdd] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modal, setModal] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: '', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });
    const [swich, setSwich] = useState<boolean>(null)



    useEffect(() => {
        getLista()

    }, [state])


    // const getLista = () => {

    //     employeedecoration.instance.getEmployeeDecorationCatalogPorPropiedades({ State: 1}, null).then(
    //         (resp: any) => {
    //             if (resp) {
    //                 setLista(resp)
    //             }

    //         }
    //     )

    // }

    const getLista = () => {

        employeedecoration.instance.getEmployeeDecorationCatalogByPropertiesRender({ State: state }, null).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                }

            }
        )

    }



    const create = () => {
        employeedecoration.setBean({
            State: 1,
            IDEmployee: _single.getAccountID(),
            // AnnotationDate:_single.getCurrenDate()

        });
        setSwich(false);
        setModal({ ...modal, "view": true });
    }

    const editaItem = () => {
        //console.log(Project.bean);
        employeedecoration.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
                setModalAdd({ ...modalAdd, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }
    const deleteItem = () => {
        employeedecoration.bean.State = 2;
        //console.log(Project.bean);
        editaItem();
        setModalC({ ...modalC, "view": false });

    }




    const head = [
        { title: 'ID', property: 'IDEmployeeDecoration', visible: true },
        { title: 'Funcionario', property: 'AccountName', visible: true },
        // { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Tipo Condecoracion', property: 'TypeDecorationName', visible: true },

        { title: 'Fecha Registro', property: 'DecorationDate', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
        { title: 'Entregado por', property: 'DeliveredBy', visible: true },
        // { title: 'Adjuntos', property: 'AttachFiles', visible: true },
        { title: 'Usuario Logueado', property: 'EmployeeName', visible: true },
        // { title: 'Adjuntos', property: 'AttachFiles', visible: true },

    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Adjuntos', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModalAdd({ ...modalAdd, "view": true }) } },
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },


        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <BasicPage titulo="Condecoraciones">
            <div className="row">
                <div className="col-md-6">
                    <label>Estado</label>
                    <select className="form-control" value={state} onChange={(e: any) => { setstate(e.target.value) }} >
                        <option value={NaN}>...</option>
                        <option value={1}>ACTIVO</option>
                        <option value={2}>BORRADOR</option>
                    </select>
                </div>
                <div className="col-md-12">

                    <BasicTable body={lista} head={head} rowSet={employeedecoration.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem}></BasicTable>
                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <>
                            <div className="row">
                                <div className="col-md-6">
                                    <AccountEditor label="Funcionario" idAccount={employeedecoration.bean.IDAccount} onChange={(e) => { employeedecoration.setBean({ ...employeedecoration.bean, "IDAccount": e.IDAccount }) }}></AccountEditor>
                                </div>
                                <div className="col-md-6">
                                    <label>Tipo Condecoracion</label>
                                    <SelectTHConstantsValue code={204} value={employeedecoration.bean.TypeDecoration} onChange={(e: any) => { employeedecoration.setBean({ ...employeedecoration.bean, "TypeDecoration": e }) }}></SelectTHConstantsValue>
                                </div>
                                <div className="col-md-6">
                                    <label>Entregado por: </label>
                                    <input type="text" name="DeliveredBy" className="form-control" value={employeedecoration.bean.DeliveredBy} onChange={employeedecoration.handleChange} />
                                </div>
                                <div className="col-md-6">

                                    <BasicSwitch label="Usar Usuario Existente ?" estado={useaccount} eventChange={(e: any) => { setUseaccount(e) }}></BasicSwitch>
                                </div>
                                {useaccount &&
                                    <>
                                        <div className="row">
                                            <div className="col-md-12">
                                                <AccountEditor label="Funcionario" idAccount={employeedecoration.bean.DeliveredBy} onChange={(e: any) => { employeedecoration.setBean({ ...employeedecoration.bean, "DeliveredBy": e.IDAccount }) }}></AccountEditor>
                                            </div>
                                        </div>

                                    </>}

                                <div className="col-md-6">
                                    <InputDate notDate label="Fecha Registro" name="DecorationDate" value={employeedecoration.bean.DecorationDate} setDate={(e) => { employeedecoration.setBean({ ...employeedecoration.bean, "DecorationDate": e }) }} />
                                </div>
                                <div className="col-md-12">
                                    <label>Descripción</label>
                                    <textarea name="Description" className="form-control" value={employeedecoration.bean.Description} onChange={employeedecoration.handleChange} />
                                </div>

                            </div>

                        </>
                    </Modal>
                    <Modal modal={modalAdd} updateModal={setModalAdd} eventModal={editaItem}>
                        <>
                            <div className="col-md-12">
                                <FileInput
                                    Media={employeedecoration.bean.Media}
                                    MediaContext={employeedecoration.bean.MediaContext}
                                    directory='Condecoraciones'
                                    label='Cargar un archivo'
                                    onCreate={({ MediaContext, Media }: any) => { employeedecoration.setBean({ ...employeedecoration.bean, "AttachFiles": JSON.stringify({ MediaContext: MediaContext, Media: Media }) }); }}
                                ></FileInput>
                            </div>
                        </>
                    </Modal>
                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item</strong>
                    </ModalConfirm>
                </div>

            </div>
        </BasicPage>
    )
}